import { render } from "./LndTeam.vue?vue&type=template&id=94075db8&lang=pug"
import script from "./LndTeam.vue?vue&type=script&lang=js"
export * from "./LndTeam.vue?vue&type=script&lang=js"

import "./LndTeam.vue?vue&type=style&index=0&id=94075db8&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__